import { makeFetchSlice, fetchHomeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import { getInvoice, InvoiceParams } from '../api'
import { INVOICE_REDUCER_NAME } from '../consts'

const invoiceSlice = makeFetchSlice(INVOICE_REDUCER_NAME)
export const invoiceReducer = invoiceSlice.reducer
export const invoiceActions = invoiceSlice.actions

export const getInvoiceThunk = (
  params: InvoiceParams,
  homeId: string,
  rootDomainId: string
) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetchHomeDataThunk({
        dispatch,
        actions: invoiceActions,
        asyncFunc: () => getInvoice(params, homeId, rootDomainId),
      })
      return response
    } catch (error) {
      console.log('Error getting invoice', error)
    }
  }
}
